import { TableTemplate } from 'types/tableTemplate';

export const reportGuideTableTemplate: TableTemplate[] = [
  {
    id: 'action',
    description: 'Ações',
    originalId: 'action',
    width: 60,
  },
  {
    id: 'id',
    description: 'ID',
    originalId: 'id',
    width: 60,
  },
  {
    id: 'formattedCreatedAt',
    description: 'Geração',
    originalId: 'created_at',
    width: 140,
  },
  {
    id: 'formattedAppointmentDate',
    description: 'Consulta',
    originalId: 'appointment_date',
    width: 110,
  },
  {
    id: 'patientProcedure',
    description: 'Paciente / Procedimento',
    originalId: 'patientProcedure',
    width: 250,
  },
  {
    id: 'formattedDoctorName',
    description: 'Parceiro',
    originalId: 'formattedDoctorName',
    width: 190,
  },
  {
    id: 'formattedMarkerName',
    description: 'Marcador',
    originalId: 'formattedMarkerName',
    width: 180,
  },
  {
    id: 'formattedPaymentMethods',
    description: 'Forma de pagamento',
    originalId: 'formattedPaymentMethods',
    width: 170,
  },
  {
    id: 'formattedValueCost',
    description: 'Custo',
    originalId: 'value_cost',
    width: 110,
    dataType: 'number',
  },
  {
    id: 'formattedValueProcedure',
    description: 'Valor de venda',
    originalId: 'value_procedure',
    width: 130,
    dataType: 'number',
  },
  {
    id: 'formattedValueTotal',
    description: 'Valor Total',
    originalId: 'value_total',
    width: 130,
    dataType: 'number',
  },
  {
    id: 'formattedStatus',
    description: 'Status',
    originalId: 'status',
    width: 120,
  },
];
